<template>
  <ls-table-layout>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="dataTable"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :columns="columns"
          :data-source="tableDataSource"
          :pagination="false"
        >
          <!-- 完成时间 -->
          <template slot="completionDate" slot-scope="text">
            {{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}
          </template>
          <!-- 要求到货时间 -->
          <template slot="deliveryDate" slot-scope="text">
            {{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}
          </template>
          <!-- 是否达标 -->
          <template slot="submittedFlag" slot-scope="text">
            {{ text === 'Y' ? '是' : '否' }}
          </template>
          <!-- 数据收集时间 -->
          <template slot="dataCollectionTime" slot-scope="text">
            {{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}
          </template>
        </a-table>
        <download-modal :apiFun="apiFun" ref="download" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import {
  apiGetDeliveryRateDetailList,
  apiGetCompletedRateDetailList,
  apiDeliveryRateDetailExport,
  apiCompletedRateDetailExport
} from '@/api/report/plan-delivery-rate'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'reportDetail',
  components: { DownloadModal },
  data () {
    return {
      apiFun: undefined,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(this.$route.query.apiType === 'delivery' ? apiGetDeliveryRateDetailList : apiGetCompletedRateDetailList, true),
        pageCurrent: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
				deliveryDate: undefined,
				organizationCode: undefined,
				type: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center',
          width: 80,
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'vendorCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划数量',
          dataIndex: 'planQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '完成数量',
          dataIndex: 'receivedQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '完成时间',
          dataIndex: 'completionDate',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'completionDate' }
        },
        {
          title: '要求到货时间',
          dataIndex: 'deliveryDate',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'deliveryDate' }
        },
        {
          title: '叫料单号',
          dataIndex: 'callDocNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '叫料单行号',
          dataIndex: 'lineNumber',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '是否达标',
          dataIndex: 'submittedFlag',
          align: 'center',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'submittedFlag' }
        },
        {
          title: '数据收集时间',
          dataIndex: 'dataCollectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'dataCollectionTime' }
        }
      ],
      tableDataSource: []
    }
  },
  created () {
    const rowData = JSON.parse(this.$route.query.row)
    this.queryParams = {
      deliveryDate: rowData.deliveryDate,
      organizationCode: rowData.organizationCode,
      type: this.$route.query.type
    }
    const apiFunMap = {
      completion: apiCompletedRateDetailExport, // 订单完成率
      delivery: apiDeliveryRateDetailExport
    }
    this.apiFun = apiFunMap[this.$route.query.apiType]
  },
  mounted () {
    this.$nextTick(() => {
      this.onSearch()
    })
  },
  methods: {
    // 导出
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
    },
    // 表单搜索
    onSearch () {
      if (this.$route.query.apiType === 'delivery') {
        apiGetDeliveryRateDetailList(this.queryParams).then((res) => {
          if (res.code === 200) {
            this.tableDataSource = res.data
          }
        })
      } else if (this.$route.query.apiType === 'completion') {
        apiGetCompletedRateDetailList(this.queryParams).then((res) => {
          if (res.code === 200) {
            this.tableDataSource = res.data
          }
        })
      }
    },
    renderCell (value, row, index, dataIndexArray) {
      const dataSource = this.tableDataSource;
      const currentValues = dataIndexArray.map(dataIndex => row[dataIndex]);
      const prevRow = index > 0 ? dataIndexArray.map(dataIndex => dataSource[index - 1][dataIndex]) : null;

      const obj = {
        children: value,
        attrs: {}
      };

      // 判断当前行的值与前一行是否相同，如果相同，则合并单元格
      if (prevRow && prevRow.every((prevValue, i) => prevValue === currentValues[i])) {
        obj.attrs.rowSpan = 0;
      } else {
        // 计算相同值出现的次数，设置 rowSpan
        let rowSpan = 1;
        for (let i = index + 1; i < dataSource.length; i++) {
          const nextValues = dataIndexArray.map(dataIndex => dataSource[i][dataIndex]);
          if (nextValues.every((nextValue, j) => nextValue === currentValues[j])) {
            rowSpan++;
          } else {
            break;
          }
        }
        obj.attrs.rowSpan = rowSpan;
      }

      return obj;
    }
  }
}
</script>

<style scoped lang="less"></style>
